<div class="release-package">
  <h3>{{ 'FEATURES.ENVIRONMENT_RELEASE_PACKAGE.TITLE' | transloco }}</h3>
  <p>{{ 'FEATURES.ENVIRONMENT_RELEASE_PACKAGE.PLACEHOLDER' | transloco }}</p>
</div>
